import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function Tooltip({ text, className = "", children }) {
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  useEffect(() => {
    if (isHovered && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top - 10,
        left: rect.left + rect.width / 2,
      });
    }
  }, [isHovered]);

  return (
    <>
      <div
        ref={triggerRef}
        className={`relative inline-block ${className}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {children || (
          <QuestionMarkCircleIcon className="w-4 h-4 text-indigo-800" />
        )}
      </div>
      {isHovered &&
        createPortal(
          <div
            className={`fixed w-80 px-4 py-2 bg-indigo-900 text-white text-sm rounded-lg text-center pointer-events-none ${text ? "" : "hidden"}`}
            style={{
              top: `${tooltipPosition.top}px`,
              left: `${tooltipPosition.left}px`,
              transform: "translate(-50%, -100%)",
              zIndex: 99999,
            }}
          >
            {text}
          </div>,
          document.body,
        )}
    </>
  );
}
